<lib-table [tableColumns]="activeVoucherColumns" [api]="api" [exportButton]="exportButton" [dateFilter]="dateFilter"
    [dropDownFilter]="dropDownFilter" [searchUIOptions]="searchUIOptions" [resourceMessages]="resourceMessages"
    [addNewButton]="false" [title]="title" [singleDateFilterDivClass]="'col-md-4'" [multiSelectDivClass]="'col-md-4'"
    [searchInputDivClass]="'col-md-4'">
</lib-table>